// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__OhbDn","col":"Table_col__1_qL4","fulfillmentStatus":"Table_fulfillmentStatus__2GQhj","emailCol":"Table_emailCol__2egiG"};